/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    testimonials: {
        menu: {
            index: 'دیدگاه‌های کاربران',
            create: 'دیدگاه جدید',
            list: 'دیدگاه‌های کاربران'
        },
        table_titles: {
            id: 'شناسه',
            user: 'نام کاربر',
            link: 'لینک نظر',
            alias: 'نام مستعار',
            comment: 'نظر',
            pinned: 'پین شده',
            show_photo: 'نمایش عکس',
            published_at: 'تاریخ انتشار',
            setting: 'ویرایش / حذف',
        },
        no: 'خیر',
        yes: 'بله',
        edit: 'ویرایش نظر کاربر'
    }
}

